import moment from 'moment-timezone';

/**
 * Return string of cs-CZ date format with time.
 *
 * @param {String} date Date string to be formatted
 * @returns {String}
 */
export function formatDateTime(date) {
  return moment(date).format('D. M. YYYY (HH:mm)');
}

/**
 * Return string of cs-CZ date format with time.
 *
 * @param {String} date Date string to be formatted
 * @returns {String}
 */
export function formatDate(date) {
  return date ? moment(date).format('D. M. YYYY') : '';
}
